import { render } from "./ViewEmployeeReport.vue?vue&type=template&id=7efa01e3"
import script from "./ViewEmployeeReport.vue?vue&type=script&lang=js"
export * from "./ViewEmployeeReport.vue?vue&type=script&lang=js"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__